const SelectField = ({
  name,
  register,
  data,
  label,
  errors,
  defaultValue,
  valueAsNumber,
  disabled,
}) => {
  return (
    <div className="input-container">
      <label htmlFor={name} className="block mb-0.5 text-text-1/90 font-medium">
        {label}
      </label>
      <select
        className="w-full bg-content px-2 py-1 border-2 border-bkg2 rounded-none text-base focus:border-bkg text-text-1/75 outline-none"
        disabled={disabled}
        defaultValue={defaultValue ? defaultValue : ""}
        {...register(name, { valueAsNumber })}
      >
        {data.map((item) => {
          return (
            <option className="text-sm" key={item.id} value={item.id}>
              {item.name}
            </option>
          );
        })}
      </select>
      {
        <p className="text-red-400 text-xs text-wrap w-fit">
          {errors && errors.message} <span className="invisible">Sample</span>
        </p>
      }
    </div>
  );
};

export default SelectField;
